// Mappers for manufacture-related entities
// Identity mappers for 1:1 mapping

import type {
  MachineEventSearchResponseDto,
  NcFileSearchResponseDto,
  NcFileDto,
  MachineEventsTimelineResponseDto,
  MachineEventsTimelineDetailsResponseDto,
} from '../../generated/models';

import type {
  ManufactureMachineEventSearchResponse,
  ManufactureNcFileSearchResponse,
  NcFile,
  MachineEventsTimelineResponse,
  MachineEventsTimelineDetailsResponse,
} from '../types';

// Response mappers (identity for 1:1)
export const toManufactureMachineEventSearchResponse = (
  dto: MachineEventSearchResponseDto
): ManufactureMachineEventSearchResponse => dto;
export const toManufactureNcFileSearchResponse = (dto: NcFileSearchResponseDto): ManufactureNcFileSearchResponse => dto;
export const toNcFile = (dto: NcFileDto): NcFile => dto;
export const toNcFileArray = (dtos: NcFileDto[]): NcFile[] => dtos;
export const toMachineEventsTimelineResponse = (dto: MachineEventsTimelineResponseDto): MachineEventsTimelineResponse =>
  dto;
export const toMachineEventsTimelineDetailsResponse = (
  dto: MachineEventsTimelineDetailsResponseDto
): MachineEventsTimelineDetailsResponse => dto;
// toMachineEvent and toMachineEventArray — already in './machine' mapper
